import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6. `userLogout`/`supportLogout`
// are web-only, and a bare `../LoginSlice` typechecks against the NATIVE variant because
// packages/core's tsconfig sets `moduleSuffixes: [".native", ".shared", ".desktop", ""]`.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedOutletState } from "./shared";

export interface OutletState extends SharedOutletState {
  toggleBranchResponse: any;
  toggleBranchInfoData : any
}

const initialState: OutletState = {
  ...sharedInitialState,
  toggleBranchResponse : {},
  toggleBranchInfoData : {}
};

export const outletStatusSlice = createSlice({
  name: "outletStatus",
  initialState,
  reducers: {
    ...sharedReducers,
    // The 7 below are web-only.
    allOutletsCallComplete: (state) => {
      // this action is to tell that the all outlets call has completed
    },
    toggleBranch: (state, action) => {},
    updateInfoModalData: (state, action) => {
      state.toggleBranchInfoData = action.payload;
    },
    updateOutletSlice: (state, action) => {
      return action.payload;
    }
  },
  // Both bodies are empty in the app source — the cases exist but reset nothing.
  // Preserved as-is; giving them a body would be a behaviour change, not a fix.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  getAllOutlets,
  getAllOutletsSuccess,
  getAllActivitiesPerOutlet,
  getAllActivitiesPerOutletSuccess,
  toggleOutlet,
  toggleOutletSuccess,
  fetchOutletStatus,
  fetchOutletStatusSuccess,
  fetchActivityError,
  fetchActivityErrorSuccess,
  clearToggleResponse,
  bulkOutletToggle,
  bulkOutletToggleSuccess,
  clearBulkToggleResponse,
  getOutletDeliveryStatus,
  getOutletDeliveryStatusSuccess,
  updateOutletDeliveryStatus,
  updateOutletDeliveryStatusSuccess,
  getHelpLink,
  getHelpLinkSuccess,
  clearAllResponsesFromOutlet,
  clearHelpLink,
  toggleBranch,
  getBranchData,
  storeBranchData,
  updateInfoModalData,
  updateOutletSlice,
  allOutletsCallComplete,
  branchDataCallComplete,
} = outletStatusSlice.actions;
export default outletStatusSlice.reducer;
